import { useState, useEffect } from "react";
import { baseUrl } from "../global/meta";


export default function useFetch(endpoint, method) {
    const [data, setData] = useState(null);
    const [request, setRequest] = useState(null)

    useEffect(() => {
      const fetchData = async () => {
          setData(null);

          try {
              const requestOptions = request ? {
                  method: method,
                  headers: {
                      'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(request.body),
              } : {
                  method: 'GET',
              };

              const response = await fetch(`${baseUrl}${endpoint}`, requestOptions);
              if (!response.ok) {
                  throw new Error(`HTTP error! Status: ${response.status}`);
              }
              const responseData = await response.json();
              setData(responseData);
          } catch (err) {
              console.log("Backend is currently down, so no blogs to show.")
          }
      };
      fetchData();
    }, [endpoint, method, request])

    const requestSetter = (body) => {
        if (method === 'POST') {
            setRequest({ body });
        }
    };

    return { data, requestSetter }
}
